(function ($, Drupal, drupalSettings) {

  "use strict";

  var windowWidth = function(){
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
  }

  Drupal.behaviors.trestonVariationQuantities = {
    attach: function(context, settings) {

    }
  }

})(jQuery, Drupal, drupalSettings);
